//
import Model from '@/models/Model'

/**
 * @class
 */
export default class SlCustomerSendEmailWithDebts extends Model {
    /**
     *
     */
    resource() {
        return 'sl_customer_send_email_with_debts'
    }
}
